// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import * as types from './actionTypes';

export function changeRestoreStatus (payload) {
	return {
		type: types.RESTORE_STATUS_CHANGE,
		payload
	};
}

export function changeStatusToSuccess () {
	const payload = {
		status: 'success'
	};

	return ((dispatch) => {
		dispatch(changeRestoreStatus(payload));
	});
}

export function changeStatusToFailure (requestIdValue) {
	const payload = {
		status: 'failure',
		requestId: requestIdValue
	};

	return ((dispatch) => {
		dispatch(changeRestoreStatus(payload));
	});
}
